import { MemberAvatar } from "@/components/MemberAvatar";
import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between gap-4">
      <div>
        <h1 className="font-display text-3xl font-bold text-ink">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ emoji = "✨", title, message, action }) {
  return (
    <div className="mt-10 flex flex-col items-center justify-center rounded-3xl border border-dashed border-border bg-secondary/40 px-6 py-16 text-center">
      <div className="mb-3 text-5xl">{emoji}</div>
      <h3 className="font-display text-xl font-semibold text-ink">{title}</h3>
      {message && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{message}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function MemberFilterBar({ members, value, onChange }) {
  return (
    <div className="mt-4 flex flex-wrap gap-2">
      <button
        onClick={() => onChange(null)}
        data-testid="member-filter-all"
        className={cn(
          "rounded-full px-4 py-1.5 text-sm font-semibold transition-colors",
          !value ? "bg-primary text-primary-foreground" : "bg-secondary text-secondary-foreground hover:bg-secondary/70"
        )}
      >
        Everyone
      </button>
      {members.map((m) => (
        <button
          key={m.id}
          onClick={() => onChange(m.id)}
          data-testid={`member-filter-${m.id}`}
          className={cn(
            "flex items-center gap-1.5 rounded-full py-1 pl-1 pr-3 text-sm font-semibold transition-colors",
            value === m.id ? "bg-primary text-primary-foreground" : "bg-secondary text-secondary-foreground hover:bg-secondary/70"
          )}
        >
          <MemberAvatar member={m} size="sm" ring={value !== m.id} />
          {m.name}
        </button>
      ))}
    </div>
  );
}

export function MemberMultiSelect({ members, value, onChange }) {
  if (!members.length) {
    return <p className="text-sm text-muted-foreground">Add family members first to assign this.</p>;
  }
  const toggle = (id) => {
    const has = value.includes(id);
    onChange(has ? value.filter((x) => x !== id) : [...value, id]);
  };
  return (
    <div className="flex flex-wrap gap-2">
      {members.map((m) => {
        const active = value.includes(m.id);
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => toggle(m.id)}
            data-testid={`assign-member-${m.id}`}
            className={cn(
              "flex items-center gap-1.5 rounded-full py-1 pl-1 pr-3 text-sm font-semibold transition-all",
              active ? "bg-accent text-accent-foreground ring-2 ring-primary" : "bg-secondary text-secondary-foreground"
            )}
          >
            <MemberAvatar member={m} size="sm" ring={false} />
            {m.name}
          </button>
        );
      })}
    </div>
  );
}
